import React from 'react';
import PaddingBox from '@uds/padding-box';
import Glyph from '@uds/glyphs';
import { Heading02, BodyCopy } from '@uds/typography';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';
import { gu2px, useTheme, Colorway as Colorways } from '@uds/theme-utils';
import callToAction from 'presentation/hocs/callToAction';
import withUrlComponent from 'presentation/hooks/withUrlComponent';
import { withHover } from '@team-griffin/stylr';
import { Layout } from 'domain/constants/layout';
import Colorway from '@uds/colorway';

import useStylesheet, { getClassNames } from './Tile.stylesheet';

export interface TileProps {
  colorway: Colorways;
  type: string;
  text: {
    body?: ShortcodeProps;
    title?: ShortcodeProps;
  };
  action: {
    url: string;
    linkAttribution?: string;
  };
  leftTile: boolean;
  rightTile: boolean;
  hBaseline: number;
  layout: Layout;
}
interface OuterProps extends TileProps {
  hover: boolean;
}

export const PureTile = ({ colorway, text, hBaseline, action, ...props }: OuterProps) => {
  const { title, body } = text;
  const { theme } = useTheme();
  const { styles } = useStylesheet({
    colorway,
    ...props,
  });
  const { Component } = withUrlComponent({ action });
  const classNames = getClassNames();
  return (
    <Component
      style={styles.root}
      href={action.url}
      to={action.url}
      id={action.linkAttribution ? action.linkAttribution : null}
    >
      <Colorway colorway={colorway}>
        <div style={styles.container}>
          <PaddingBox>
            <div className={classNames.box}>
              <div className={classNames.wrapperText}>
                <Heading02 className={classNames.title} depth={hBaseline + 1}>
                  <Shortcode against={colorway} code={title} />
                </Heading02>
                <BodyCopy component="p" className={classNames.subtitle}>
                  <Shortcode against={colorway} code={body} />
                </BodyCopy>
              </div>
              <div className={classNames.wrapperIcon}>
                <span style={styles.icon}>
                  <Glyph name="arrowRight" size={gu2px(3, theme.spacing)} color={styles.icon.color as string} />
                </span>
              </div>
            </div>
          </PaddingBox>
        </div>
      </Colorway>
    </Component>
  );
};

PureTile.displayName = 'Tile';

export default callToAction(withHover(PureTile));
